import React, { useContext } from "react";
import {
  Avatar,
  Box,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../../assets/colors";
import {
  convertINRDecimals,
  formatAsPercentage,
  setCryptoDecimals,
} from "../../utils";
import { useMemo } from "react";
import { AuthContext } from "../../context/auth";
import { FlexLayerContext } from "../../context/flexLayer";

export default function PaymentModeModal({
  open,
  close,
  options,
  amount,
  onSelect,
  type,
}) {
  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle position="relative">
        <Typography variant="h6" textAlign="center">
          Choose a payment option
        </Typography>
        <Box sx={{ position: "absolute", top: "8px", right: "8px" }}>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: "30px" }}>
        {options &&
          options.map((data, i) => {
            return (
              <PaymentCoin
                data={data}
                key={`paymentOption${i}`}
                amount={amount}
                onSelect={onSelect}
                close={close}
                type={type}
              />
            );
          })}
      </DialogContent>
    </Dialog>
  );
}

const PaymentCoin = ({ data, amount, onSelect, close, type }) => {
  const auth = useContext(AuthContext);
  const { coinListData } = useContext(FlexLayerContext);
  const { wallet } = auth?.userData;
  const discountedAmount = useMemo(() => {
    const discountAmount = (Number(amount) * Number(data?.discount)) / 100;
    return Number(amount) - discountAmount;
  }, [amount]);

  const availableBalance = useMemo(() => {
    return wallet[data?.coinId?.symbol][
      type === "bnpl" ? "balance" : "margin_balance"
    ];
  }, [data?.coinId?.symbol]);

  const quantity = useMemo(() => {
    const findData =
      coinListData &&
      coinListData.find((x) => x.symbol === data?.coinId?.symbol);

    return Number(discountedAmount) / Number(findData?.current_price);
  }, [coinListData, data?.coinId?.symbol, discountedAmount]);

  console.log("quantity---", quantity);

  return (
    <Card
      sx={{ padding: "10px", marginBottom: "8px", cursor: "pointer" }}
      onClick={() => {
        onSelect(discountedAmount, data?.coinId?.symbol, data?.discount);
        close();
      }}
    >
      <Box className="displaySpacebetween">
        <Box display={"flex"} alignItems={"center"}>
          <Avatar
            src={data?.coinId?.icon}
            alt="icon"
            sx={{ width: "30px", height: "30px" }}
          />
          <Box ml={0.5}>
            <Box display={"flex"} alignItems={"center"}>
              <Typography variant="body2">
                {data && data.coinId && data.coinId.symbol}
              </Typography>
              {data?.discount > 0 && (
                <Typography
                  variant="body1"
                  sx={{ color: colors.green }}
                  ml={0.5}
                >
                  {`(-${formatAsPercentage(data?.discount)})`}
                </Typography>
              )}
            </Box>

            <Typography variant="body1">
              {availableBalance ? setCryptoDecimals(availableBalance) : "0"}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <Typography variant="body2" fontWeight={600} mr={0.5}>
            {discountedAmount ? convertINRDecimals(discountedAmount) : "--"}
          </Typography>
          {discountedAmount !== quantity && (
            <Typography variant="body2">
              {quantity ? `(≈${setCryptoDecimals(quantity)})` : "--"}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
};
